/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiGSIncomePlayerList } from '@/api/gsManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'roleDetail',
  props: {
    gameId: {
      type: Number,
      default: undefined
    },
    currencyList: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const currentCurrency = ref('USD');
    const activeKey = ref('roleDetail');
    const panes = ref([{
      title: '角色明细',
      key: 'roleDetail'
    }]);
    const filter = reactive({
      role_id: '',
      role_nickname: ''
    });
    const columns = [{
      label: '角色ID',
      prop: 'role_id',
      width: 100
    }, {
      label: '角色昵称',
      prop: 'role_nickname'
    }, {
      label: '绑定GS名称',
      prop: 'gs_chairman_name'
    }, {
      label: '绑定GS时间',
      prop: 'created_at',
      slot: 'created_at'
    }, {
      label: '最近登录时间',
      prop: 'login_at',
      slot: 'login_at'
    }, {
      label: '充值总额',
      prop: 'charge_amount',
      header: 'charge_amount_header'
    }];
    const getTableData = async () => {
      tableLoading.value = true;
      const res = await apiGSIncomePlayerList({
        ...filter,
        is_over_view: 1,
        current_page: current.value,
        page_size: pageSize.value,
        game_id: props.gameId,
        currency: currentCurrency.value
      });
      tableLoading.value = false;
      if (res.code === 0 && res.data) {
        tableData.value = res.data;
        total.value = res.meta && res.meta.pagination && res.meta.pagination.total || 0;
      }
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSearch,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    watch(() => props.gameId, val => {
      if (val) getTableData();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      const _component_el_input = __unplugin_components_2;
      const _component_el_form_item = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      const _component_el_form = __unplugin_components_5;
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createBlock(_component_u_card, {
        modelValue: _unref(activeKey),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(activeKey) ? activeKey.value = $event : null),
        panes: _unref(panes),
        class: "margin-pane"
      }, {
        extra: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _unref(currentCurrency),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currentCurrency) ? currentCurrency.value = $event : null),
          style: {
            "width": "160px"
          },
          onChange: getTableData
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.currencyList, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.currency
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        "left-extra": _withCtx(() => [_createVNode(_component_el_form, {
          inline: "",
          class: "search-container"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入角色ID",
              modelValue: _unref(filter).role_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).role_id = $event),
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入角色昵称",
              modelValue: _unref(filter).role_nickname,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(filter).role_nickname = $event),
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(handleSearch)
            }, {
              default: _withCtx(() => [_createTextVNode("搜索")]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(UTable, {
          loading: _unref(tableLoading),
          "row-key": "id",
          options: columns,
          data: _unref(tableData),
          total: _unref(total),
          pagination: "",
          onSizeChange: _unref(handleSizeChange),
          onCurrentChange: _unref(handleCurrentChange)
        }, {
          charge_amount_header: _withCtx(() => [_createElementVNode("span", null, "充值总额 (" + _toDisplayString(_unref(currentCurrency)) + ")", 1)]),
          created_at: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(_ctx.$filters.formatDate(scope.row.created_at)), 1)]),
          login_at: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(_ctx.$filters.formatDate(scope.row.login_at)), 1)]),
          _: 1
        }, 8, ["loading", "data", "total", "onSizeChange", "onCurrentChange"])]),
        _: 1
      }, 8, ["modelValue", "panes"]);
    };
  }
});